import { createSlice } from "@reduxjs/toolkit"

import { StoreItem } from "#/shared/constants"

type StoreState = {
  products: StoreItem[]
  currentProduct: StoreItem | null
  collectedProductIds: string[]
}

const initialState: StoreState = {
  products: [],
  currentProduct: null,
  collectedProductIds: [],
}

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    setProducts: (immerState, { payload }: { payload: StoreItem[] }) => {
      immerState.products = payload
    },
    setCurrentProduct: (immerState, { payload }: { payload: StoreItem }) => {
      immerState.currentProduct = payload
    },
    resetCurrentProduct: (immerState) => {
      immerState.currentProduct = null
    },
    setCollectedProductIds: (
      immerState,
      { payload }: { payload: string[] },
    ) => {
      immerState.collectedProductIds = payload
    },
    resetCollectedProductIds: (immerState) => {
      immerState.collectedProductIds = []
    },
    resetProductsState: (immerState) => ({
      ...immerState,
      currentProduct: null,
      collectedProductIds: [],
    }),
  },
})

export const {
  setProducts,
  setCurrentProduct,
  resetCurrentProduct,
  setCollectedProductIds,
  resetCollectedProductIds,
  resetProductsState,
} = storeSlice.actions

export default storeSlice.reducer
